<section class="tpk" data-testid="testpakete-karte">
  <div class="tpk__kopf">
    <div class="tpk__titelblock">
      <h2 class="tpk__titel">{{ 'testPlans.packages.title' | translate }}</h2>
      <p class="tpk__untertitel">{{ 'testPlans.packages.subtitle' | translate }}</p>
    </div>
    @if (!schreibgeschuetzt()) {
      <button
        mat-flat-button
        color="primary"
        type="button"
        data-testid="testpaket-neu"
        [disabled]="!testfaelle().length || store.ladeStatus() !== 'bereit'"
        (click)="oeffneDialog(null)"
      >
        <span aria-hidden="true">＋</span>
        {{ 'testPlans.packages.add' | translate }}
      </button>
    }
  </div>

  @switch (store.ladeStatus()) {
    @case ('laedt') {
      <div class="tpk__status" data-testid="testpakete-laden" role="status">
        <mat-progress-spinner mode="indeterminate" diameter="16" aria-hidden="true" />
        {{ 'testPlans.packages.loading' | translate }}
      </div>
    }
    @case ('fehler') {
      <div class="tpk__status tpk__status--fehler" data-testid="testpakete-fehler" role="alert">
        {{ 'testPlans.packages.loadError' | translate }}
        <button type="button" class="tpk__knopf" (click)="store.laden()">
          {{ 'testPlans.packages.retry' | translate }}
        </button>
      </div>
    }
    @default {
      @if (!testfaelle().length) {
        <div class="tpk__leer" data-testid="testpakete-leer">{{ 'testPlans.packages.empty' | translate }}</div>
      }
      @if (testfaelle().length && offen().length) {
        <div class="tpk__offen" data-testid="testpakete-offen">
          <span class="tpk__offen-text">
            {{
              (offen().length === 1 ? 'testPlans.packages.unassignedOne' : 'testPlans.packages.unassignedMany')
                | translate: { count: offen().length }
            }}
          </span>
          @for (testfall of offen(); track testfall.id) {
            <code class="tpk__offen-chip">{{ testfall.key }}</code>
          }
        </div>
      }

      @if (pakete().length) {
        @let k = kennzahlen();
        @let f = store.filter();
        <div class="tpk__uebersicht">
          <div class="tpk__kennzahlen" data-testid="pakete-kennzahlen">
            <span>
              <strong>{{ k.pakete }}</strong>
              {{ 'testPlans.packages.statPackages' | translate }}
            </span>
            <span>
              <strong>{{ k.testfaelle }}</strong>
              {{ 'testPlans.packages.statTestCases' | translate }}
            </span>
            <span class="tpk__kennzahl-unv" [class.tpk__kennzahl-unv--offen]="k.unvollstaendig > 0">
              <strong>{{ k.unvollstaendig }}</strong>
              {{ 'testPlans.packages.statIncomplete' | translate }}
            </span>
            <span>
              <strong>{{ k.laeufe }}</strong>
              {{ 'testPlans.packages.statRuns' | translate }}
            </span>
          </div>

          <div class="tpk__werkzeuge">
            <div class="tpk__suche">
              <mat-icon class="tpk__suche-icon" aria-hidden="true">search</mat-icon>
              <input
                type="search"
                class="tpk__suchfeld"
                data-testid="pakete-suche"
                [placeholder]="'testPlans.packages.search' | translate"
                [attr.aria-label]="'testPlans.packages.searchAria' | translate"
                [value]="f.suche"
                (input)="store.setzeSuche(wert($event))"
              />
            </div>
            <select
              class="tpk__auswahl"
              [attr.aria-label]="'testPlans.packages.filterStageAria' | translate"
              (change)="store.setzeFilterStufe(wert($event))"
            >
              <option value="" [selected]="!f.stufe">{{ 'testPlans.packages.allStages' | translate }}</option>
              @for (stufe of filterStufen(); track stufe.id) {
                <option [value]="stufe.id" [selected]="stufe.id === f.stufe">{{ stufe.name }}</option>
              }
            </select>
            <select
              class="tpk__auswahl"
              [attr.aria-label]="'testPlans.packages.filterEnvironmentAria' | translate"
              (change)="store.setzeFilterUmgebung(wert($event))"
            >
              <option value="" [selected]="!f.umgebung">
                {{ 'testPlans.packages.allEnvironments' | translate }}
              </option>
              @for (umgebung of filterUmgebungen(); track umgebung) {
                <option [value]="umgebung" [selected]="umgebung === f.umgebung">{{ umgebung }}</option>
              }
            </select>
            <button
              type="button"
              class="tpk__schalter"
              data-testid="pakete-nur-unvollstaendig"
              [class.tpk__schalter--an]="f.nurUnvollstaendig"
              [attr.aria-pressed]="f.nurUnvollstaendig"
              (click)="store.schalteNurUnvollstaendig()"
            >
              {{ 'testPlans.packages.onlyIncomplete' | translate }}
            </button>
          </div>

          @if (store.markiert().length) {
            <div
              class="tpk__sammel"
              role="region"
              data-testid="pakete-sammelbearbeitung"
              [attr.aria-label]="'testPlans.packages.bulkRegion' | translate"
            >
              <strong class="tpk__sammel-titel">
                {{ 'testPlans.packages.marked' | translate: { count: store.markiert().length } }}
              </strong>
              <select
                class="tpk__auswahl tpk__auswahl--klein"
                [attr.aria-label]="'testPlans.packages.bulkStageAria' | translate"
                (change)="sammelStufe($event)"
              >
                <option value="" selected>{{ 'testPlans.packages.bulkStage' | translate }}</option>
                @for (stufe of stufen(); track stufe.id) {
                  <option [value]="stufe.id">{{ stufe.name }}</option>
                }
              </select>
              <select
                class="tpk__auswahl tpk__auswahl--klein"
                [attr.aria-label]="'testPlans.packages.bulkEnvironmentAria' | translate"
                (change)="sammelUmgebung($event)"
              >
                <option value="" selected>{{ 'testPlans.packages.bulkEnvironment' | translate }}</option>
                @for (umgebung of projektUmgebungen(); track umgebung) {
                  <option [value]="umgebung">{{ umgebung }}</option>
                }
              </select>
              <button
                type="button"
                class="tpk__sammel-entfernen"
                data-testid="pakete-markierte-entfernen"
                (click)="store.entferneMarkierte()"
              >
                {{ 'testPlans.packages.bulkRemove' | translate }}
              </button>
              <button
                type="button"
                class="tpk__sammel-aufheben"
                data-testid="pakete-markierung-aufheben"
                (click)="store.hebeMarkierungAuf()"
              >
                {{ 'testPlans.packages.clearMarks' | translate }}
              </button>
            </div>
          }
        </div>

        <div class="tpk-tabelle">
          <div class="tpk-tabelle__kopf tpk-raster">
            <input
              type="checkbox"
              class="tpk-tabelle__haken"
              [checked]="alleMarkiert()"
              [disabled]="schreibgeschuetzt()"
              [attr.aria-label]="'testPlans.packages.markAll' | translate"
              (change)="store.schalteAlle(gefilterteKeys())"
            />
            <span></span>
            <span>{{ 'testPlans.packages.colPackage' | translate }}</span>
            <span>{{ 'testPlans.packages.colStage' | translate }}</span>
            <span>{{ 'testPlans.packages.colEnvironments' | translate }}</span>
            <span>{{ 'testPlans.packages.colTestCases' | translate }}</span>
            <span class="tpk-tabelle__status-kopf">
              <span>{{ 'testPlans.packages.colStatus' | translate }}</span>
              <span>{{ 'testPlans.packages.colAction' | translate }}</span>
            </span>
          </div>
          <div class="tpk-tabelle__koerper">
            @if (!sichtbar().length) {
              <div class="tpk-tabelle__leer" data-testid="pakete-keine-treffer">
                {{ 'testPlans.packages.noMatch' | translate }}
              </div>
            }
            @for (eintrag of sichtbar(); track eintrag.paket.key) {
              @let p = eintrag.paket;
              @let auf = store.offenKey() === p.key;
              @let markiert = store.markiert().includes(p.key);
              <div class="tpk-paket" data-testid="testpaket">
                <div
                  class="tpk-paket__zeile tpk-raster"
                  [class.tpk-paket__zeile--offen]="auf"
                  [class.tpk-paket__zeile--markiert]="markiert && !auf"
                >
                  <input
                    type="checkbox"
                    class="tpk-tabelle__haken"
                    [checked]="markiert"
                    [disabled]="schreibgeschuetzt()"
                    [attr.aria-label]="'testPlans.packages.mark' | translate: { name: p.name }"
                    (change)="store.schalteMarkierung(p.key)"
                  />
                  <button
                    type="button"
                    class="tpk-paket__klapp"
                    data-testid="testpaket-aufklappen"
                    [attr.aria-expanded]="auf"
                    [attr.aria-label]="
                      (auf ? 'testPlans.packages.collapse' : 'testPlans.packages.expand') | translate: { name: p.name }
                    "
                    (click)="schalteOffen(p.key)"
                  >
                    <mat-icon class="tpk-paket__chevron" [class.tpk-paket__chevron--offen]="auf" aria-hidden="true">
                      chevron_right
                    </mat-icon>
                  </button>
                  <button
                    type="button"
                    class="tpk-paket__name"
                    data-testid="testpaket-name"
                    (click)="schalteOffen(p.key)"
                  >
                    {{ p.name }}
                  </button>
                  <span class="tpk-paket__text" data-testid="testpaket-stufe">{{ stufenName(p) }}</span>
                  <span
                    class="tpk-paket__text tpk-paket__umg"
                    data-testid="testpaket-umgebungen"
                    [class.tpk-paket__umg--fehlt]="!p.environments.length"
                  >
                    {{
                      p.environments.length
                        ? p.environments.join(', ')
                        : ('testPlans.packages.environmentMissing' | translate)
                    }}
                  </span>
                  <span class="tpk-paket__text tpk-paket__tf" data-testid="testpaket-tf">
                    {{ eintrag.testfaelle.length }}
                  </span>
                  <span class="tpk-paket__status" data-testid="testpaket-status">
                    @switch (eintrag.lauf?.status) {
                      @case ('laeuft') {
                        <span class="tpk-lauf__laeuft" role="status">
                          <span class="tpk-lauf__spinner" aria-hidden="true"></span>
                          {{ 'testPlans.packages.trialRunning' | translate }}
                        </span>
                      }
                      @case ('fertig') {
                        <span class="tpk-lauf__fertig">
                          @for (lauf of laufListe(eintrag); track lauf.id) {
                            <a
                              class="tpk-lauf__chip"
                              data-testid="paket-lauf"
                              [routerLink]="laufLink(lauf)"
                              [title]="'testPlans.packages.trialRunTitle' | translate"
                            >
                              ✓ {{ lauf.key }}
                            </a>
                          }
                          @if (!schreibgeschuetzt()) {
                            <button
                              type="button"
                              class="tpk-lauf__nochmal"
                              [attr.aria-label]="'testPlans.packages.again' | translate"
                              [title]="'testPlans.packages.again' | translate"
                              (click)="store.setzeLaufZurueck(p.key)"
                            >
                              ↻
                            </button>
                          }
                        </span>
                      }
                      @default {
                        <span class="tpk-badge" [class.tpk-badge--bereit]="eintrag.vollstaendig">
                          {{
                            (eintrag.vollstaendig ? 'testPlans.packages.ready' : 'testPlans.packages.incompleteStatus')
                              | translate
                          }}
                        </span>
                        @if (!schreibgeschuetzt()) {
                          @if (!eintrag.vollstaendig) {
                            <button
                              type="button"
                              class="tpk-ergaenzen"
                              data-testid="paket-ergaenzen"
                              [title]="
                                (p.environments.length
                                  ? 'testPlans.packages.completeTestCases'
                                  : 'testPlans.packages.completeEnvironment'
                                ) | translate
                              "
                              (click)="oeffne(p.key)"
                            >
                              <mat-icon class="tpk-ergaenzen__icon" aria-hidden="true">edit</mat-icon>
                              {{ 'testPlans.packages.complete' | translate }}
                            </button>
                          } @else if (!ohneStartrecht()) {
                            @let gesperrt = startGesperrt(p);
                            <button
                              type="button"
                              class="tpk-probelauf"
                              data-testid="paket-probelauf"
                              [disabled]="gesperrt"
                              [attr.aria-label]="'testPlans.packages.trialAria' | translate: { name: p.name }"
                              [title]="
                                (gesperrt ? 'testPlans.packages.saveFirst' : 'testPlans.packages.trialTitle')
                                  | translate
                              "
                              (click)="starteProbelauf(p.key)"
                            >
                              <span class="tpk-probelauf__dreieck" aria-hidden="true">▶</span>
                              {{ 'testPlans.packages.trial' | translate }}
                            </button>
                          }
                        }
                      }
                    }
                  </span>
                </div>

                @if (auf) {
                  <div class="tpk-details" data-testid="testpaket-details">
                    <div class="tpk-details__kopf">
                      <mat-icon class="tpk-details__icon" fontSet="material-icons-outlined" aria-hidden="true">
                        content_copy
                      </mat-icon>
                      <input
                        class="tpk-details__name"
                        type="text"
                        required
                        [attr.aria-label]="'testPlans.packages.name' | translate"
                        [attr.maxlength]="fieldLengths.TEST_PACKAGE_NAME_MAX"
                        [value]="p.name"
                        [disabled]="schreibgeschuetzt()"
                        (input)="umbenennen(p, $event)"
                      />
                      @if (!eintrag.vollstaendig) {
                        <span class="tpk-details__badge">{{ 'testPlans.packages.incomplete' | translate }}</span>
                      }
                      @if (!schreibgeschuetzt()) {
                        <button
                          type="button"
                          class="tpk-details__entfernen"
                          [attr.aria-label]="'testPlans.packages.remove' | translate"
                          [title]="'testPlans.packages.remove' | translate"
                          (click)="store.entferne(p.key)"
                        >
                          <mat-icon fontSet="material-icons-outlined" aria-hidden="true">delete</mat-icon>
                        </button>
                      }
                    </div>

                    <div class="tpk-details__zeile">
                      <span class="tpk__label">{{ 'testPlans.packages.stage' | translate }}</span>
                      <select
                        class="tpk-details__stufe"
                        [attr.aria-label]="'testPlans.packages.stage' | translate"
                        [disabled]="schreibgeschuetzt()"
                        (change)="waehleStufe(p, $event)"
                      >
                        <option value="" [selected]="!p.projectTestStageId">
                          {{ 'testPlans.packages.noStage' | translate }}
                        </option>
                        @for (stufe of stufen(); track stufe.id) {
                          <option [value]="stufe.id" [selected]="stufe.id === p.projectTestStageId">
                            {{ stufe.name }}
                          </option>
                        }
                      </select>
                      <span class="tpk-details__trenner" aria-hidden="true"></span>
                      <span class="tpk__label">
                        {{ 'testPlans.packages.environments' | translate }}
                        <span class="tpk__pflicht" aria-hidden="true">*</span>
                      </span>
                      @for (umgebung of eintrag.umgebungen; track umgebung) {
                        @let an = gewaehlt(p, umgebung);
                        <button
                          type="button"
                          class="tpk-chip"
                          data-testid="testpaket-umgebung"
                          [disabled]="store.umgebungen().status !== 'bereit' || schreibgeschuetzt()"
                          [class.tpk-chip--an]="an"
                          [attr.aria-pressed]="an"
                          (click)="store.schalteUmgebung(p.key, umgebung)"
                        >
                          @if (an) {
                            <mat-icon class="tpk-chip__haken" aria-hidden="true">check</mat-icon>
                          }
                          <span class="tpk-chip__text">{{ umgebung }}</span>
                        </button>
                      }
                      @if (store.umgebungen().status === 'fehler') {
                        <ng-container
                          *ngTemplateOutlet="
                            nachschlagFehler;
                            context: {
                              testid: 'testpaket-umgebungen-fehler',
                              key: 'testPlans.packages.environmentsError',
                            }
                          "
                        />
                      } @else if (store.umgebungen().status === 'bereit' && !eintrag.umgebungen.length) {
                        <span class="tpk-details__hinweis" data-testid="testpaket-keine-umgebung">
                          {{ 'testPlans.packages.noEnvironment' | translate }}
                        </span>
                      }
                      @if (umgebungAnlegbar() && store.umgebungen().status === 'bereit') {
                        <input
                          class="tpk-weitere"
                          type="text"
                          data-testid="tp-paket-umgebung-weitere"
                          [placeholder]="'testPlans.packages.environmentMore' | translate"
                          [attr.aria-label]="'testPlans.packages.environmentMoreAria' | translate"
                          [disabled]="store.umgebungAnlage()"
                          (input)="umgebungHinweis.set(null)"
                          (keydown.enter)="legeUmgebungAn(p, $event)"
                        />
                        @if (umgebungHinweis()?.key === p.key) {
                          <span
                            class="tpk-details__hinweis tpk-details__hinweis--fehler"
                            role="alert"
                            data-testid="testpaket-umgebung-hinweis"
                          >
                            {{ umgebungHinweis()?.text }}
                          </span>
                        }
                      }
                      @if (p.environments.length > 1) {
                        <span class="tpk-details__hinweis" data-testid="testpaket-laufanzahl">
                          {{ 'testPlans.packages.runCount' | translate: { count: p.environments.length } }}
                        </span>
                      }
                    </div>

                    <div class="tpk-details__testfaelle">
                      <div class="tpk-details__testfaelle-kopf">
                        <span class="tpk__label">
                          {{ 'testPlans.packages.testCases' | translate: { count: eintrag.testfaelle.length } }}
                        </span>
                        @if (!schreibgeschuetzt()) {
                          <button
                            type="button"
                            class="tpk__knopf tpk__knopf--akzent"
                            data-testid="testpaket-testfaelle-waehlen"
                            (click)="oeffneDialog(p.key)"
                          >
                            <span aria-hidden="true">＋</span>
                            {{ 'testPlans.packages.chooseTestCases' | translate }}
                          </button>
                        }
                      </div>
                      @if (!eintrag.testfaelle.length) {
                        <p class="tpk-details__keine-testfaelle">
                          {{ 'testPlans.packages.noTestCases' | translate }}
                        </p>
                      }
                      <ul class="tpk-details__testfall-liste">
                        @for (testfall of eintrag.testfaelle; track testfall.id) {
                          <li class="tpk-details__testfall" data-testid="testpaket-testfall">
                            <code class="tpk-details__testfall-key">{{ testfall.key }}</code>
                            <span class="tpk-details__testfall-titel">{{ testfall.title }}</span>
                            @if (!schreibgeschuetzt()) {
                              <button
                                type="button"
                                class="tpk-details__testfall-entfernen"
                                [attr.aria-label]="
                                  'testPlans.packages.removeTestCase' | translate: { key: testfall.key }
                                "
                                [title]="'testPlans.packages.removeTestCaseTitle' | translate"
                                (click)="entferneTestfall(p, testfall.id)"
                              >
                                <mat-icon aria-hidden="true">close</mat-icon>
                              </button>
                            }
                          </li>
                        }
                      </ul>
                    </div>
                  </div>
                }
              </div>
            }
            @if (gefiltert().length > store.anzahl()) {
              <div class="tpk-tabelle__mehr" data-testid="pakete-mehr">
                <span>
                  {{ 'testPlans.packages.shown' | translate: { shown: store.anzahl(), total: gefiltert().length } }}
                </span>
                <button type="button" class="tpk__knopf tpk__knopf--akzent" (click)="store.mehrLaden()">
                  {{ 'testPlans.packages.loadMore' | translate }}
                </button>
              </div>
            }
          </div>
        </div>

        <div class="tpk__fuss" data-testid="pakete-fuss">
          <span class="tpk__fuss-tag">{{ 'testPlans.packages.footerTag' | translate }}</span>
          &ngsp;
          <span>{{ 'testPlans.packages.footerText' | translate }}</span>
          &ngsp;
          <a class="tpk__fuss-link" [routerLink]="['/projects', store.projektId(), 'test-runs']">
            {{ 'testPlans.packages.footerLink' | translate }}
          </a>
        </div>
      }
    }
  }
</section>

<ng-template #nachschlagFehler let-testid="testid" let-key="key">
  <span class="tpk-details__fehler" role="alert" [attr.data-testid]="testid">
    {{ key | translate }}
    <button type="button" class="tpk__knopf" (click)="store.ladenNachschlag()">
      {{ 'testPlans.packages.retry' | translate }}
    </button>
  </span>
</ng-template>
